export default function Machines_D_1 (number = 1) {
  return {
    name: '制作台Mk.Ⅱ',
    icon: '/static/img/machines/d1.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_D/Machines_D_1.js